<script lang="ts">
  import { router } from 'tinro';
  import { Route } from 'tinro';
  import Landing from './routes/Landing.svelte';
  import BudgetApp from './routes/BudgetApp.svelte';

  // Enable history-based routing (proper paths, not hash)
  router.mode.history();
</script>

<Route path="/">
  <Landing />
</Route>

<Route path="/app/*">
  <BudgetApp />
</Route>

<style>
  :global(body) {
    margin: 0;
    padding: 0;
  }
</style>
